import { useMemo } from 'react';
import { TemplateType_Slug } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { TemplatorV2Queries } from '@frontend/api-templator-v2';
import { formatDynamicFieldKey } from '@frontend/string';
import { TagType } from '@frontend/design-system';

export const useGetTemplateTags = (selectedLocationIds: string[]) => {
  const templateTypeQuery = TemplatorV2Queries.useTemplateTypesList(
    {
      businessGroupIds: selectedLocationIds,
      templateTypeSlugs: [TemplateType_Slug.MANUAL_SCHEDULE_QUICK_FILL],
    },
    {
      select: (data) =>
        data.templateTypes
          .find((template) => template.slug === TemplateType_Slug.MANUAL_SCHEDULE_QUICK_FILL)
          ?.dynamicFields.reduce<TagType[]>((acc, dynamicField) => {
            const { label, key, exampleValues } = dynamicField;
            if (label && key) {
              acc.push({
                label,
                key: formatDynamicFieldKey(key),
                value: exampleValues?.[0] ?? '',
                optional: !dynamicField.isRequired,
                nonRemovable: !!dynamicField.isRequired,
              });
            }
            return acc;
          }, []) ?? [],
      enabled: !!selectedLocationIds.length,
    }
  );

  const { templateTags } = useMemo(() => {
    const tags = templateTypeQuery.data ?? [];
    return { templateTags: tags };
  }, [templateTypeQuery.data]);

  return { templateTags, isLoadingTemplateTags: templateTypeQuery.isLoading };
};
